import Container from "./Container";

export default function PageHeader({ label, labelClass = "", title, lede, mark = false, logo = null }) {
  return (
    <header className="pb-10 pt-28 md:pb-14 md:pt-32">
      <Container>
        {label ? <p className={`kicker ${labelClass}`}>{label}</p> : null}
        <h1 className={`${label ? "mt-4" : ""} flex max-w-3xl items-center gap-4 text-4xl font-semibold leading-[1.1] tracking-tight text-[var(--ink)] sm:text-5xl`}>
          {logo}
          <span>{title}</span>
        </h1>
        {mark ? <div className="mt-6 h-0.5 w-16 bg-[var(--kicker)]" aria-hidden="true" /> : null}
        {lede ? (
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-[var(--muted)]">{lede}</p>
        ) : null}
      </Container>
    </header>
  );
}
